"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetEnergySavingChartData = void 0;
const react_1 = require("react");
const useGetSensorChartData_1 = require("../sensors/useGetSensorChartData");
const DEFAULT_RATE_PER_KWH = 0.12;
const DEFAULT_CURRENT = 0;
const DEFAULT_VOLTAGE = 120;
const HOURS_PER_DAY = 24;
const MILLIWATTS_IN_KWH = 1000;
const useGetEnergySavingChartData = ({ historicalData, translate, daysToShow = 7, }) => {
    const ct1 = (0, useGetSensorChartData_1.useGetSensorChartData)(historicalData, 'main_ct1', translate, undefined, daysToShow);
    const ct2 = (0, useGetSensorChartData_1.useGetSensorChartData)(historicalData, 'main_ct2', translate, undefined, daysToShow);
    const vt1 = (0, useGetSensorChartData_1.useGetSensorChartData)(historicalData, 'vt1', translate, undefined, daysToShow);
    const vt2 = (0, useGetSensorChartData_1.useGetSensorChartData)(historicalData, 'vt2', translate, undefined, daysToShow);
    const data = (0, react_1.useMemo)(() => ct1.data.map((ct1Reading, idx) => {
        const ct1Value = ct1Reading?.value || DEFAULT_CURRENT;
        const ct2Value = ct2.data[idx]?.value || DEFAULT_CURRENT;
        const vt1Value = vt1.data[idx]?.value || DEFAULT_VOLTAGE;
        const vt2Value = vt2.data[idx]?.value || DEFAULT_VOLTAGE;
        const powerWatts = (ct1Value + ct2Value) * (vt1Value + vt2Value);
        const energyKWh = (powerWatts * HOURS_PER_DAY) / MILLIWATTS_IN_KWH;
        const cost = energyKWh * DEFAULT_RATE_PER_KWH;
        return {
            label: ct1Reading.label,
            value: cost,
        };
    }), [ct1.data, ct2.data, vt1.data, vt2.data]);
    return { data };
};
exports.useGetEnergySavingChartData = useGetEnergySavingChartData;
